export default __webpack_public_path__ + "static/media/shortcut.262681a8.svg";